import React from "react";
import "../Events.css";

const StoWFilter = (props) => {
  return (
    <>
      <div className="AthleteSearchBanner main-filter-event testimonial-title">
        <h1>Commitment Videos</h1>
        <div className="AthleteSearchFilterContainer"></div>
      </div>
    </>
  );
};

export default StoWFilter;
